import React, { useContext, useState } from "react";
import { useNavigate } from "react-router";
import ButtonLoader from "../components/ButtonLoader";
import { UserContext } from "../context";
import { validate } from "../utils/validation";
import hIMage from "../Assets/img/h-image.png";
import fIMage from "../Assets/img/f-image.png";
import footer from "../Assets/img/footer.png";
import useWindowDimensions from "../components/dimensions";

export default function Login() {
  const [errors, setErrors] = useState(null);
  const [inputs, setInputs] = useState({ name: "", email: "" });
  const [loading, setLoading] = useState(false);

  const { width } = useWindowDimensions();

  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);
  // const { error, setError } = useContext(ErrorContext);

  async function handleChange({ target }) {
    let { name, value } = target;
    value = name === "email" ? value.trim() : value;
    setInputs((prev) => ({
      ...prev,
      [name]:
        name === "name" &&
        inputs[name].length &&
        inputs[name][inputs[name].length - 1] === " " &&
        value.length &&
        value[value.length - 1] === " "
          ? inputs[name]
          : name === "email"
          ? value.trim()
          : name === "phone" && isNaN(value)
          ? prev.phone
          : value,
    }));

    handleValidation({ name, value });
  }

  async function handleValidation(target = null) {
    let err = {};

    if (target) {
      err = {
        ...errors,
        [target.name]: validate[target.name](target.value),
      };
    } else {
      setLoading(true);
      for (let key in inputs) {
        err[key] = validate[key](inputs[key]);
      }
    }
    setErrors(err);

    for (let key in err) {
      if (err[key]) return false;
    }
    return true;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!loading) {
      if (await handleValidation()) {
        // let body = new FormData();
        // for (let key in inputs) body.append(key, inputs[key]);
        // login({
        //   body,
        //   setError,
        //   setLoading,
        //   callback: (userId) => {
        //     setUser({ ...inputs, userId: userId });
        //     navigate("/capture");
        //   },
        // });

        setUser(inputs);
        navigate("/capture");
      }
      // else {
      //   setLoading(false);
      // }
    }
  }

  return (
    <>
      <div
        className="main-wrapper"
        // style={width > 500 ? { display: "none" } : {}}
        style={width > 400 ? { maxWidth: 300, margin: "0 auto" } : {}}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src={hIMage} alt="" />
          <span style={{ fontSize: 20, fontWeight: 500, color: "#fff" }}>
            A healthy festive initiative by
          </span>
          <img src={fIMage} alt="" style={{ maxWidth: "50%", marginTop: 6 }} />
        </div>
        <section className="login-form">
          <div className="title">Please Enter Your Details</div>
          <form onSubmit={handleSubmit} style={{ paddingBottom: 0 }}>
            <div className="form-group">
              <label style={{ fontSize: "unset" }}>Name</label>
              <input
                className="form-control"
                name="name"
                onChange={handleChange}
                type="text"
                value={inputs.name}
              />
              <span className="input-err">{errors?.name}</span>
            </div>

            <div className="form-group">
              <label style={{ fontSize: "unset" }}>Email Id</label>
              <input
                className="form-control"
                name="email"
                onChange={handleChange}
                type="text"
                value={inputs.email}
              />
              <span className="input-err">{errors?.email}</span>
            </div>

            {/* <div className="form-group">
              <label style={{fontSize:"unset"}}>Mobile No.</label>
              <input
                className="form-control"
                name="phone"
                onChange={handleChange}
                type="text"
                value={inputs.phone}
              />
              <span className="input-err">{errors?.phone}</span>
            </div> */}

            <div
              className="form-group"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {false ? (
                <span className="server-err">{"Someting went wrong"}</span>
              ) : (
                <button type="submit" className="login-btn">
                  {loading ? (
                    <ButtonLoader style={{ padding: ".5rem" }} />
                  ) : (
                    "Enter"
                  )}
                </button>
              )}
            </div>
          </form>
        </section>
        <div style={{ textAlign: "center" }}>
          <img
            src={footer}
            alt=""
            style={width > 400 ? { maxWidth: "90%" } : {}}
          />
        </div>
      </div>
      {/* <div id="warning-message">
        This photo-booth is only viewable in mobile portrait mode.
      </div> */}
    </>
  );
}
